export default {
  PhoneNumber: {
    getMessage(field) {
      return `${field} is not a valid phone number`;
    },
    validate(value) {
      return /^0(\d{9,9})$/g.test(value);
    }
  },
  ten_length: {

    validate(value) {
      return /^.{10}$/g.test(value);
    }
  },
  cmnd_number: {
    validate(value) {
      return /^(0[0-8][0-9]|09[0-6])[0-3]\d{8}$/.test(value);
    }
  },
  cmnd_name: {
    validate(value) {
      return /^[a-zA-ZÀÁÂÃÈÉÊÌÍÌỈĨÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíìỉĩòóôõùúăđĩũơƯưẠạẢảÂâẤấẦầẨẩẪẫẬậĂăẮắẰằẲẳẴẵẶặÉéÈèẺẻẼẽẸẹÊêẾếỀềỂểỄễỆệÍíÌìỈỉĨĩỊịÓóÒòỎỏÕõỌọÔôỐốỒồỔổỖỗỘộƠơỚớỜờỞởỠỡỢợÚúÙùỦủŨũỤụƯưỨứỪừỬửỮữỰựÝýỲỳỶỷỸỹỴỵ\s]+$/u.test(value);
    }
  },
  required: {
    validate: value => !!value,
  },

  Path: {
    validate: value => (/^([a-zA-Z\d-_.~]*)$/).test(value)
  },

  ensure_url: {
    validate: value => (/^(http[s]?\:\/\/)*(?!(\w+\:\/\/))+(\w|\d|\w\d|\d|.*)?[^\.{1,2}]\.?(\w|\d|\w\d|\d)+\.[^\.{1,2}]/g).test(value),
  },

  no_spaces: {
    validate: value => (/^[\S]*$/).test(value)
  },

  not_digits: {
    validate: value => {
      return !(/(\d)/g).test(value);
    }
  },

  not_symbols: {
    validate: (value) => /^[a-zA-Z0-9]+$/.test(value)
  },

  /**
   * @description only allow letters and space, not allowed the symbols
   */
  not_symbols_allowed_space: {
    validate: (value) => {
      return /^[a-zA-Z\d\s(à|á|ả|ã|ạ|ă|â|ê|ư|ắ|ằ|ẵ|ẳ|ặ|ầ|ấ|ẩ|ẫ|ậ|è|é|ẻ|ẽ|ẹ|ư|ừ|ữ|ử|ứ|ự|ề|ế|ể|ễ|ệ|ù|ú|ủ|ũ|ụ|ư|ừ|ứ|ữ|ử|ự|ô|ồ|ố|ỗ|ổ|ộ|i|ì|í|ỉ|ĩ|ị|y|ỳ|ý|ỷ|ỹ|ỵ|o|ò|ó|ỏ|õ|ọ|ươ|ườ|ướ|ưỡ|ưở|ượ|đ|À|Á|Ả|Ã|Ạ|Ă|Â|Ê|Ư|Ắ|Ằ|Ẵ|Ẳ|Ặ|Ầ|Ấ|Ẩ|Ẫ|Ậ|È|É|Ẻ|Ẽ|Ẹ|Ư|Ừ|Ữ|Ử|Ứ|Ự|Ề|Ế|Ể|Ễ|Ệ|Ù|Ú|Ủ|Ũ|Ụ|Ư|Ừ|Ứ|Ữ|Ử|Ự|Ô|Ồ|Ố|Ỗ|Ổ|Ộ|I|Ì|Í|Ỉ|Ĩ|Ị|Y|Ỳ|Ý|Ỷ|Ỹ|Ỵ|O|Ò|Ó|Ỏ|Õ|Ọ|ƯƠ|ƯỜ|ƯỚ|ƯỠ|ƯỞ|ƯỢ|Đ)]+$/.test(value)
    }
  },

  /**
   * password1Level: Meaning the password require level 1, at least one validate uppercase, lowercase and number
   */
  password_level_1: {
    validate: (value) => {
      return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])?.{8,}$/.test(value)
    }
  },

  customer_identity_number: {
    validate: (value) => {
      return /^(\d{9,9})$/g.test(value) || /^(\d{12,12})$/g.test(value);
    }
  },

  not_allowed_vietnamese: {
    validate: (value) => {
      const parts = value.split("@");
      const name = parts[0];
      return /^[a-zA-Z0-9._%+-]+$/.test(name);
    }
  },

  different: {
    params: ['target'],
    validate(value, target) {
      return value !== target[0];
    },
  },

  different_pw: {
    params: ['target'],
    validate(value, target) {
      return value !== target[0];
    },
  },
}



// WEBPACK FOOTER //
// ./src/plugins/veeValidate/rules.js